import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
const Container = React.forwardRef(({ className, size = 'lg', ...props }, ref) => {
    const sizeClasses = {
        sm: 'max-w-2xl',
        md: 'max-w-4xl',
        lg: 'max-w-6xl',
        xl: 'max-w-7xl',
        full: 'max-w-full'
    };
    return (_jsx("div", { ref: ref, className: cn('mx-auto px-4 sm:px-6 lg:px-8', sizeClasses[size], className), ...props }));
});
Container.displayName = 'Container';
export { Container };
